const initialState = {
  activeView: "",
  previousView: "",
  activeFilterView: "",
  loggedIn: false,
  experiments: {
    favouritesEnabled: false,
  },
};

const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_VIEW": {
      // if the user has left the betShuffle view, we want to set the previous view to the active view
      // so that when they close the edit/add favourites modal they are returned to the bet shuffle view before the favourites list
      if (state.activeView === "betShuffle" && action.payload) {
        return {
          ...state,
          activeView: action.payload,
          previousView: state.activeView,
        };
      }

      // if the payload is null or an empty string reset everything as the user returns to the main screen
      if (!action.payload) {
        return {
          ...state,
          activeView: "",
          previousView: "",
        };
      }

      // default behaviour
      return {
        ...state,
        activeView: action.payload,
      };
    }
    case "SET_ACTIVE_FILTER_VIEW":
      return {
        ...state,
        activeFilterView: action.payload,
      };
    case "LoggedInState":
      return {
        ...state,
        loggedIn: action.payload.loggedIn,
      };
    case "Experimentation":
      return {
        ...state,
        experiments: {
          ...state.experiments,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default viewReducer;
